import { Loading } from "@dgs/core";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router";
import { registrationFormService } from "../../shared/api/registrationForms";
import { useRegistrationForm } from "../provider/registrationFormProviderContext";
import { StaticStepForm } from "./StaticStepForm";

export const RegistrationDeclinePage = () => {
	const {
		registrationForm: { id, guest, isDeclinable },
		declineRegistration,
	} = useRegistrationForm();
	const { data, isLoading } = useQuery({
		queryKey: registrationFormService.keys.showConfirmDeclination(id),
		queryFn: () => registrationFormService.showConfirmDeclination(id).then((x) => x.data.data),
	});
	const navigate = useNavigate();

	if (!isDeclinable) {
		navigate("../landing-page");
	}

	if (isLoading || !data) {
		return <Loading />;
	}

	return (
		<StaticStepForm
			step={data.step}
			handleSubmit={declineRegistration}
			guestAttributeValues={guest.guestAttributeValues}
		/>
	);
};
